var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRfuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00016 12.5L6.50016 10M9.00016 12.5C10.1642 12.0573 11.2809 11.499 12.3335 10.8334M9.00016 12.5V16.6667C9.00016 16.6667 11.5252 16.2084 12.3335 15C13.2335 13.65 12.3335 10.8334 12.3335 10.8334M6.50016 10C6.94362 8.84957 7.502 7.74676 8.16683 6.70838C9.13781 5.15587 10.4898 3.87758 12.0943 2.99512C13.6988 2.11266 15.5024 1.65535 17.3335 1.66671C17.3335 3.93338 16.6835 7.91671 12.3335 10.8334M6.50016 10H2.3335C2.3335 10 2.79183 7.47504 4.00016 6.66671C5.35016 5.76671 8.16683 6.66671 8.16683 6.66671M2.75016 13.75C1.50016 14.8 1.0835 17.9167 1.0835 17.9167C1.0835 17.9167 4.20016 17.5 5.25016 16.25C5.84183 15.55 5.8335 14.475 5.17516 13.825C4.85125 13.5159 4.42457 13.3372 3.97702 13.3234C3.52946 13.3096 3.09256 13.4615 2.75016 13.75Z",
    stroke: "#5C667B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfuIcon);
export default __webpack_public_path__ + "static/media/rfuIcon.44a55fa6df7fdeea93f2a6425ff9ac92.svg";
export { ForwardRef as ReactComponent };